import {actions} from "react-fields";

export default class TestimonialsAPI {

    static search(options) {
        let url = `/api/testimonials`;
        return fetch(actions.getData(`${url}?${actions.paramsToURI(options)}`))
            .then(actions.status)
            .then(actions.json)
    }

}